import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'

class FlywheelCompleted extends React.Component {
	render() {
		const { migrate } = this.props
		return <div className="fw d-flex">
			<div className="container">
				<div className="jumbotron">
					<img className="checkmark-circle" src="/assets/checkmark_circle.svg" alt=""/>
					<h1 className="fw-600">Your migration is complete!</h1>
					<p>
						<a href={migrate.get('source_site')} target="_blank" className="font16">{migrate.get('source_site')}</a>
						<img className="arrow-icon" src="/assets/arrow_right.svg" alt=""/>
						<a href={migrate.get('destination_site')} target="_blank" className="font16">{ migrate.get('destination_site') }</a>
					</p>
				</div>
				<hr/>
				<div className="subsection">
					<p className="text-center font13">Click through your Flywheel-hosted site for quality assurance. If anything is amiss, drop us a line via a <a href="https://app.getflywheel.com/tickets/new?source=blogvault">Support Ticket</a>.</p>
				</div>
				<div className="text-center font13">
					<a href={migrate.get('flywheel_url')} target="_blank" className="button big-green-button">Go to Flywheel</a>
				</div>
			</div>
		</div>
	}
}

FlywheelCompleted.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default FlywheelCompleted
